import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { theme } from "../../Theme";
import Avatar from "../../assets/avatar.jpeg";
import ArXivLogo from "../../assets/arxiv-logo.png";
import AclLogo from "../../assets/acl-logo.png";
import Socials from "../Socials";
import { Link } from "rebass";
import { FaGithub, FaFilePdf } from "react-icons/fa";
import content from "./RawContent";

const hue = keyframes`
    from {
        -webkit-filter: hue-rotate(0deg);
    }
    to {
        -webkit-filter: hue-rotate(45deg);
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 750px;
    gap: 42px;
    padding: 22px 0;
    @media screen and (max-width: 555px) {
        flex-direction: column;
        gap: 22px;
        max-width: 100%;
    }
`;

const Title = styled.span`
    font-size: 32px;
    letter-spacing: 0.01rem;
    -webkit-animation: ${hue} 2s infinite linear;
    background: ${theme().grad4};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation-direction: alternate;
`

const ProfileSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const ProfileSectionAlt = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`

const AvatarWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
        width: 240px;
        border-radius: 6px;
    }
`

const ContentMediaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 180px;
    img {
        max-width: 180px;
        max-height: 180px;
        border-radius: 6px;
    }
`

const ItemList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: center;
    gap: 22px;
    width: 100%;
`

const ContentBase = styled.span`
    line-height: 1.5;
    color: ${({color}) => color};
`

const ContentLink = styled(ContentBase)`
    font-size: 12px;
`

const ContentTitle = styled(ContentBase)`
    font-size: 14px;
    font-weight: 600;
`

const ContentAuthors = styled(ContentBase)`
    font-size: 14px;
`

const ContentYear = styled(ContentBase)`
    font-size: 14px;
`

const ContentJournal = styled(ContentBase)`
    font-size: 14px;
    font-style: italic;
`

const ContentNote = styled(ContentBase)`
    font-size: 10px;
`

const ContentDescription = styled(ContentBase)`
    font-size: 12px;
`

const ContentBio = styled(ContentBase)`
    font-size: 12px;
    display: inline-block;
`

const ContentDisplay = ({ data, darkMode }) => {

  return (
    <div style={{ display: "flex" }}>
      <div style={{
        display: "flex",
        //background: theme(darkMode).bgBox,
        padding: "12px",
        borderRadius: "6px",
        border: `1px solid ${theme(darkMode).borderBox}`,
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        gap: "12px",
      }}>
        <div style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "left",
        }}>
          {data['media'] !== null &&
            <ContentMediaWrapper>
              <img src={data['media']}/>
            </ContentMediaWrapper>
          }
        </div>
        <div style={{
          display: "flex",
          flexDirection: "column",
        }}>
          <div>
            <ContentTitle color={theme(darkMode).titleColor}>
              {data['title']}
            </ContentTitle>
          </div>
          <div>
            <ContentAuthors color={theme(darkMode).textColor}>
              {data['authors']}
            </ContentAuthors>
          </div>
          {data['journal'] !== null
            ? <div>
                <ContentJournal color={theme(darkMode).textColor}>
                  {data['journal']}
                </ContentJournal>
                <ContentYear color={theme(darkMode).textColor}>
                  {`, ${data['year']}`}
                </ContentYear>
              </div>
            : <div>
              <ContentYear color={theme(darkMode).textColor}>
                {`${data['year']}`}
              </ContentYear>
            </div>
          }
          {data['note'] !== null &&
            <div>
              <ContentNote color={theme(darkMode).textColor}>
                {data['note']}
              </ContentNote>
            </div>
          }
          {(data['arxivLink'] !== null || data['codeLink'] !== null || data['pdfLink'] !== null) && <div style={{height: "6px"}}/>}
          <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
          }}>
            {data['arxivLink'] !== null &&
              <Link href={`${data['arxivLink']}`} target="_blank" style={{ cursor: "pointer", textDecoration: "none" }}>
                <div style={{display: "flex", flexDirection: "row", gap: "6px", alignItems: "center"}}>
                  <img src={ArXivLogo} height={12} color={theme(darkMode).iconColor} alt={"arxiv-logo"}/>
                  <ContentLink color={theme(darkMode).titleColor}>{"arXiv"}</ContentLink>
                </div>
              </Link>
              }
            {data['codeLink'] !== null &&
                <Link href={`${data['codeLink']}`} target="_blank" style={{ cursor: "pointer", textDecoration: "none" }}>
                  <div style={{display: "flex", flexDirection: "row", gap: "6px", alignItems: "center"}}>
                    <FaGithub size={12} color={theme(darkMode).iconColor} />
                    <ContentLink color={theme(darkMode).titleColor}>{"GitHub"}</ContentLink>
                  </div>
                </Link>
              }
            {data['pdfLink'] !== null &&
              <Link href={`${data['pdfLink']}`} target="_blank" style={{ cursor: "pointer", textDecoration: "none" }}>
                <div style={{display: "flex", flexDirection: "row", gap: "6px", alignItems: "center"}}>
                  <FaFilePdf size={12} color={theme(darkMode).iconColor} />
                  <ContentLink color={theme(darkMode).titleColor}>{"PDF"}</ContentLink>
                </div>
              </Link>
              }
            {data['aclLink'] !== null &&
              <Link href={`${data['aclLink']}`} target="_blank" style={{ cursor: "pointer", textDecoration: "none" }}>
                <div style={{display: "flex", flexDirection: "row", gap: "6px", alignItems: "center"}}>
                  <img src={AclLogo} height={12} color={theme(darkMode).iconColor} alt={"acl-logo"}/>
                  <ContentLink color={theme(darkMode).titleColor}>{"ACL Anthology"}</ContentLink>
                </div>
              </Link>
              }
          </div>
          <div style={{height: "12px"}}/>
          <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
            <ContentDescription color={theme(darkMode).textColor}>
              {data['description']}
            </ContentDescription>
          </div>
        </div>
      </div>
    </div>
  );
}

const Content = ({ darkMode }) => {

  const [section, setSection] = useState(1)

  const bio = (
    <ContentBio color={theme(darkMode).textColor}>
      {"I'm a researcher working with "}
      <Link href={"https://as.nyu.edu/faculty/kanchan-chandra.html"} target="_blank" style={{ cursor: "pointer", textDecoration: "none", color: theme(darkMode).titleColor }}>
        {"Prof. Kanchan Chandra"}
      </Link>
      {" on methods to detect coded appeals in natural language. "}
      {"I'm also the founder of "}
      <Link href={"https://crunchtimeodds.com/"} target="_blank" style={{ cursor: "pointer", textDecoration: "none", color: theme(darkMode).titleColor }}>
        {"CrunchtimeOdds"}
      </Link>
      {", where I build high-throughput systems for prediction markets"}
      {". Previously, "}
      {"I led full-stack development for a Discord automation platform, "}
      {"worked on an outpatient chatbot at "}
      <Link href={"https://www.linkedin.com/company/intelligent-automation-inc/"} target="_blank" style={{ cursor: "pointer", textDecoration: "none", color: theme(darkMode).titleColor }}>
        {"Intelligent Automation, a BlueHalo Company"}
      </Link>
      {", and with anti-money laundering data at "}
      <Link href={"https://www.linkedin.com/company/jefferies/"} target="_blank" style={{ cursor: "pointer", textDecoration: "none", color: theme(darkMode).titleColor }}>
        {"Jefferies"}
      </Link>
      {". I did my MS in Computer Science at "}
      <Link href={"https://cims.nyu.edu/"} target="_blank" style={{ cursor: "pointer", textDecoration: "none", color: theme(darkMode).titleColor }}>
        {"New York University"}
      </Link>
      {" and my BA in Statistics at the "}
      <Link href={"https://as.virginia.edu/"} target="_blank" style={{ cursor: "pointer", textDecoration: "none", color: theme(darkMode).titleColor }}>
        {"University of Virginia"}
      </Link>
      {", where I did undergraduate research with "}
      <Link href={"https://kevindriscoll.info/"} target="_blank" style={{ cursor: "pointer", textDecoration: "none", color: theme(darkMode).titleColor }}>
        {"Prof. Kevin Driscoll"}
      </Link>
      {"."}
    </ContentBio>
  );

  return (
    <>
      <Container>
        <ProfileSection>
          <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "center", }}>
            <Title>{"Rahul Zalkikar"}</Title>
          </div>
          <div style={{height: "22px"}}/>
          <div style={{ display: "flex", flexDirection: "row", width: "100%", }}>
            <span style={{ color: theme(darkMode).textColor }}>
              {bio}
            </span>
          </div>
          <div style={{height: "22px"}}/>
          <Socials iconColor={theme(darkMode).iconColor} textColor={theme(darkMode).titleColor} />
        </ProfileSection>
        <AvatarWrapper>
          <img src={Avatar} alt={"avatar"}/>
        </AvatarWrapper>
      </Container>
      <Container>
        <ProfileSectionAlt>
          <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "left", gap: "22px" }}>
            <span style={{
              color: section === 1
                ? theme(darkMode).textColor3
                : theme(darkMode).textColor2,
              //fontWeight: 600,
              fontSize: "22px",
              cursor: "pointer"
            }} onClick={() => {
              setSection(1)
            }}>
              {"Research"}
            </span>
            <span style={{
              color: section === 2
                ? theme(darkMode).textColor3
                : theme(darkMode).textColor2,
              //fontWeight: 600,
              fontSize: "22px",
              cursor: "pointer"
            }} onClick={() => {
              setSection(2)
            }}>
              {"Projects"}
            </span>
          </div>
        </ProfileSectionAlt>
      </Container>
      <Container>
        <ProfileSectionAlt>
          {/*<Divider2 />*/}
          {section === 1
            &&
            <>
              {/*<div style={{ display: "flex", flexDirection: "row", paddingBottom: "22px", width: "100%", justifyContent: "left" }}>
                <span style={{ color: theme(darkMode).textColor, fontWeight: 600, fontSize: "1.4rem" }}>{"Publications"}</span>
              </div>*/}
              <ItemList>
                {content.filter(item => item.type == "research").map((item, index) => {
                  return (
                    <ContentDisplay data={item} darkMode={darkMode} />
                  );
                })}
              </ItemList>
            </>
          }
          {section === 2
            &&
            <>
              {/*<div style={{ display: "flex", flexDirection: "row", paddingBottom: "22px", width: "100%", justifyContent: "left" }}>
                <span style={{ color: theme(darkMode).textColor, fontWeight: 600, fontSize: "1.4rem" }}>{"Projects"}</span>
              </div>*/}
              <ItemList>
                {content.filter(item => item.type == "project").map((item, index) => {
                  return (
                    <ContentDisplay data={item} darkMode={darkMode} />
                  );
                })}
              </ItemList>
            </>
          }
        </ProfileSectionAlt>
      </Container>
    </>
  );
};

export default Content;